var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-pb-sm layout-padding" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h5",
          { staticClass: "q-pa-md col-12" },
          [
            _c("q-icon", { attrs: { color: "primary", name: "fa fa-user" } }),
            _vm._v("User Details\n      ")
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label": "First name is required",
              error: _vm.validation.userForm.USER_FIRST_NAME.$error
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "First Name",
                value: _vm.userForm.USER_FIRST_NAME,
                after: [
                  {
                    icon: "flag",
                    condition: _vm.validation.userForm.USER_FIRST_NAME.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition:
                      !_vm.validation.userForm.USER_FIRST_NAME.$invalid &&
                      _vm.validation.userForm.USER_FIRST_NAME.$dirty
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                blur: _vm.validation.userForm.USER_FIRST_NAME.$touch,
                keyup: function($event) {
                  _vm.updateUserForm({
                    field: "USER_FIRST_NAME",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-4" },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Middle Name",
                value: _vm.userForm.USER_MIDDLE_NAME,
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateUserForm({
                    field: "USER_MIDDLE_NAME",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              error: _vm.validation.userForm.USER_LAST_NAME.$error,
              "error-label": "Last name is required"
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Last Name",
                value: _vm.userForm.USER_LAST_NAME,
                after: [
                  {
                    icon: "flag",
                    condition: _vm.validation.userForm.USER_LAST_NAME.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition:
                      !_vm.validation.userForm.USER_LAST_NAME.$invalid &&
                      _vm.validation.userForm.USER_LAST_NAME.$dirty
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                blur: _vm.validation.userForm.USER_LAST_NAME.$touch,
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateUserForm({
                    field: "USER_LAST_NAME",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "q-field",
          { staticClass: "q-pa-md col-2" },
          [
            _c("q-select", {
              attrs: {
                "float-label": "Suffix",
                value: _vm.userForm.USER_SUFFIX,
                options: _vm.suffixOptions,
                disable: !_vm.canEdit
              },
              on: {
                change: function(val) {
                  return _vm.updateUserForm({
                    field: "USER_SUFFIX",
                    value: val
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-3",
            attrs: {
              error: _vm.validation.userForm.USER_DOB.$error,
              "error-label": "Invalid Date",
              helper: "MM/DD/YYYY"
            }
          },
          [
            _c("sl-date-time", {
              attrs: {
                disable: !_vm.canEdit,
                value: _vm.userForm.USER_DOB,
                "float-label": "Date of Birth",
                after: [
                  {
                    icon: "flag",
                    condition: _vm.validation.userForm.USER_DOB.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition:
                      !_vm.validation.userForm.USER_DOB.$invalid &&
                      _vm.validation.userForm.USER_DOB.$dirty
                  }
                ],
                width: "100%",
                required: ""
              },
              on: {
                input: function(newVal) {
                  return _vm.updateUserForm({
                    field: "USER_DOB",
                    value: newVal
                  })
                },
                blur: _vm.validation.userForm.USER_DOB.$touch
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-3" },
          [
            _c("q-select", {
              attrs: {
                "float-label": "Gender",
                filter: "",
                "autofocus-filter": "",
                value: _vm.userForm.USER_GENDER,
                options: _vm.genderOptions,
                disable: !_vm.canEdit
              },
              on: {
                change: function(val) {
                  return _vm.updateUserForm({
                    field: "USER_GENDER",
                    value: val
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              error: _vm.validation.userForm.USER_EMAIL.$error,
              "error-label": "Must be a valid email"
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Email",
                value: _vm.userForm.USER_EMAIL,
                after: [
                  {
                    icon: "flag",
                    condition: _vm.validation.userForm.USER_EMAIL.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition:
                      !_vm.validation.userForm.USER_EMAIL.$invalid &&
                      _vm.validation.userForm.USER_EMAIL.$dirty
                  }
                ],
                disable:
                  !_vm.canEdit ||
                  (!_vm.$p(
                    ["ADMIN", "AFFILIATE", "MANAGER", "RECRUITER"],
                    "or"
                  ) &&
                    !_vm.userWizardModalOpen),
                required: ""
              },
              on: {
                blur: _vm.validation.userForm.USER_EMAIL.$touch,
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateUserForm({
                    field: "USER_EMAIL",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-3",
            attrs: {
              error: _vm.validation.userForm.USER_PHONE.$error,
              "error-label": "Phone must be numeric"
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "(999) 999-9999",
                  expression: "'(999) 999-9999'"
                }
              ],
              attrs: {
                "float-label": "Phone",
                type: "tel",
                value: _vm.userForm.USER_PHONE,
                after: [
                  {
                    icon: "flag",
                    condition: _vm.validation.userForm.USER_PHONE.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition:
                      !_vm.validation.userForm.USER_PHONE.$invalid &&
                      _vm.validation.userForm.USER_PHONE.$dirty
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                blur: _vm.validation.userForm.USER_PHONE.$touch,
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateUserForm({
                    field: "USER_PHONE",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-2" },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Ext",
                value: _vm.userForm.USER_PHONE_EXT,
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateUserForm({
                    field: "USER_PHONE_EXT",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-3" },
          [
            _c("q-input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "999-999-9999",
                  expression: "'999-999-9999'"
                }
              ],
              attrs: {
                "float-label": "Fax",
                value: _vm.userForm.USER_FAX,
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateUserForm({
                    field: "USER_FAX",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-3",
            attrs: { helper: "Please be careful!" }
          },
          [
            _vm.$p(["ADMIN"])
              ? _c("q-input", {
                  directives: [
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "9999999999999999999",
                      expression: "'9999999999999999999'"
                    }
                  ],
                  attrs: {
                    "float-label": "Customer ID (Auth.net)",
                    value: _vm.userForm.CUSTOMER_ID,
                    disable: !_vm.canEdit,
                    required: ""
                  },
                  on: {
                    keyup: function($event) {
                      $event.stopPropagation()
                      _vm.updateUserForm({
                        field: "CUSTOMER_ID",
                        value: $event.target.value
                      })
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm.anyActiveRole && !_vm.userWizardModalOpen
      ? _c("div", { staticClass: "user-roles row" }, [
          _c("div", { staticClass: "col-12 q-pa-md" }, [
            _c(
              "h5",
              [
                _c("q-icon", {
                  attrs: { name: "fa fa-bolt", color: "primary" }
                }),
                _vm._v("\n          Current Roles\n          "),
                _vm.$p(["ADMIN", "MANAGER", "RECRUITER", "AFFILIATE"], "or")
                  ? _c(
                      "q-btn",
                      {
                        attrs: { outline: "", size: "sm" },
                        nativeOn: {
                          click: function($event) {
                            _vm.updateSelectedTab("roles")
                          }
                        }
                      },
                      [_vm._v("\n              Manage Roles\n          ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "col-12 q-pa-md" },
            [
              _c(
                "q-list",
                { staticClass: "round", attrs: { separator: "" } },
                [
                  _vm.administratorForm.ACTIVE_IND
                    ? _c(
                        "q-item",
                        [
                          _c("q-item-main", [
                            _c(
                              "h6",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    color: "primary",
                                    name: "fa fa-magic"
                                  }
                                }),
                                _vm._v(" Administrator")
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.managerForm.ACTIVE_IND
                    ? _c(
                        "q-item",
                        [
                          _c("q-item-main", [
                            _c(
                              "h6",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    color: "primary",
                                    name: "fa fa-users"
                                  }
                                }),
                                _vm._v(" Manager")
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.affiliateForm.ACTIVE_IND
                    ? _c(
                        "q-item",
                        [
                          _c("q-item-main", [
                            _c(
                              "h6",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    color: "primary",
                                    name: "fa fa-building"
                                  }
                                }),
                                _vm._v(" Affiliate")
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.recruiterForm.ACTIVE_IND
                    ? _c(
                        "q-item",
                        [
                          _c("q-item-main", [
                            _c(
                              "h6",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    color: "primary",
                                    name: "fa fa-user-plus"
                                  }
                                }),
                                _vm._v(" Recruiter")
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.instructorForm.ACTIVE_IND
                    ? _c(
                        "q-item",
                        [
                          _c("q-item-main", [
                            _c(
                              "h6",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    color: "primary",
                                    name: "fa fa-graduation-cap"
                                  }
                                }),
                                _vm._v(" Instructor")
                              ],
                              1
                            )
                          ]),
                          _vm.instructorForm.LK_INSTRUCTOR_STATUS_ID == 1
                            ? _c("div", { staticClass: "label bg-green" }, [
                                _vm._v("Approved")
                              ])
                            : _vm._e(),
                          !_vm.instructorForm.LK_INSTRUCTOR_STATUS_ID
                            ? _c("div", { staticClass: "label bg-red" }, [
                                _vm._v("Awaiting Approval")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }